export const config = {
  name: 'Streamfreu(n)de',
  subtitle: 'Video & Voice Chat',
  footer: 'Powered by LiveKit',
  lang: 'de',
  themeColor: '#070707',

  // Room defaults
  defaultRoom: 'gaming' as string,
  joinButtonLabel: 'Beitreten',
} as const;
